module.exports = {
	"config": {
		"siteTitle": "Griddle",
		"baseColor": "#512DA8",
		"linkPrefix": "/Griddle",
		"docPages": [
			"/docs/",
			"/docs/architecture/",
			"/docs/customization/",
			"/docs/styles/",
			"/docs/plugins/",
			"/docs/pluginList/",
			"/docs/api/"
		],
		"examplePages": [
			"/examples/controlling-griddle/",
			"/examples/asList/",
			"/examples/asMap/",
			"/examples/defaultSort/",
			"/examples/nestedData/",
			"/examples/getDataFromRowIntoCell/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/api",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/api",
				"stem": "index",
				"path": "docs/api/index.md",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/api/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/api/index.md",
			"path": "/docs/api/",
			"data": {
				"title": "API"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/architecture",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/architecture",
				"stem": "index",
				"path": "docs/architecture/index.md",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/architecture/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/architecture/index.md",
			"path": "/docs/architecture/",
			"data": {
				"title": "Architecture"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/customization",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "docs/customization",
				"stem": "index",
				"path": "docs/customization/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/customization/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/customization/index.jsx",
			"path": "/docs/customization/",
			"data": {
				"title": "Customization",
				"order": 5
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "docs",
				"stem": "index",
				"path": "docs/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/index.jsx",
			"path": "/docs/",
			"data": {
				"title": "Getting started",
				"order": 5
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/pluginList",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "docs/pluginList",
				"stem": "index",
				"path": "docs/pluginList/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/pluginList/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/pluginList/index.jsx",
			"path": "/docs/pluginList/",
			"data": {
				"title": "Plugin List",
				"order": 5
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/plugins",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/plugins",
				"stem": "index",
				"path": "docs/plugins/index.md",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/plugins/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/plugins/index.md",
			"path": "/docs/plugins/",
			"data": {
				"title": "Plugins"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/styles",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/styles",
				"stem": "index",
				"path": "docs/styles/index.md",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/docs/styles/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/styles/index.md",
			"path": "/docs/styles/",
			"data": {
				"title": "Styles"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "examples",
				"stem": "_template",
				"path": "examples/_template.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/examples/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "examples/_template.jsx",
			"templatePath": "/examples/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "examples/asList",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "examples/asList",
				"stem": "index",
				"path": "examples/asList/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/examples/asList/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "examples/asList/index.jsx",
			"path": "/examples/asList/",
			"data": {
				"title": "As a list of \"cards\"",
				"order": 0
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples/asMap",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "examples/asMap",
				"stem": "index",
				"path": "examples/asMap/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/examples/asMap/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "examples/asMap/index.jsx",
			"path": "/examples/asMap/",
			"data": {
				"title": "As a map",
				"order": 3
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples/controlling-griddle",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "examples/controlling-griddle",
				"stem": "index",
				"path": "examples/controlling-griddle/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/examples/controlling-griddle/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "examples/controlling-griddle/index.jsx",
			"path": "/examples/controlling-griddle/",
			"data": {
				"title": "Externally Controlled Griddle",
				"order": 6
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples/defaultSort",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "examples/defaultSort",
				"stem": "index",
				"path": "examples/defaultSort/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/examples/defaultSort/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "examples/defaultSort/index.jsx",
			"path": "/examples/defaultSort/",
			"data": {
				"title": "With a default sort",
				"order": 4
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples/getDataFromRowIntoCell",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "examples/getDataFromRowIntoCell",
				"stem": "index",
				"path": "examples/getDataFromRowIntoCell/index.js",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/examples/getDataFromRowIntoCell/index.js",
				"isAbsolute": false
			},
			"requirePath": "examples/getDataFromRowIntoCell/index.js",
			"path": "/examples/getDataFromRowIntoCell/",
			"data": {
				"title": "Get data from Row into Cell",
				"order": 4
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples/nestedData",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "examples/nestedData",
				"stem": "index",
				"path": "examples/nestedData/index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/examples/nestedData/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "examples/nestedData/index.jsx",
			"path": "/examples/nestedData/",
			"data": {
				"title": "Nested data",
				"order": 4
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/Users/ryan/projects/javascript/griddle-docs/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0